export default [
    {
        id: 1,
        name_ca: 'Habitatges',
        name_en: 'Housing',
        name_es: 'Viviendas',
        name_db: 'residential'
    },
    {
        id: 2,
        name_ca: 'Oficines',
        name_en: 'Office',
        name_es: 'Oficinas',
        name_db: 'office'
    },
    {
        id: 3,
        name_ca: 'Locals i Naus',
        name_en: 'Retail and Industrial',
        name_es: 'Locales y Naves',
        name_db: 'retail_and_industrial'
    },
    {
        id: 4,
        name_ca: 'Aparcaments',
        name_en: 'Parking',
        name_es: 'Garajes',
        name_db: 'parking'
    },
    {
        id: 5,
        name_ca: 'Trasters',
        name_en: 'Storage',
        name_es: 'Trasteros',
        name_db: 'storage'
    },
    {
        id: 6,
        name_ca: 'Edificis',
        name_en: 'Buildings',
        name_es: 'Edificios',
        name_db: 'entire_buildings'
    },
    {
        id: 7,
        name_ca: 'Terrenys',
        name_en: 'Land',
        name_es: 'Terrenos',
        name_db: 'land'
    }
]



// WEBPACK FOOTER //
// ./src/options/ad_types.js